import { manageCarrierServiceTypes } from '@/common/constants'

export const manageCarrierServiceOptions = [
  {
    label: 'Automatizar gestión logística con Reveni',
    value: manageCarrierServiceTypes.auto,
  },
  {
    label: 'De forma manual',
    value: manageCarrierServiceTypes.manual,
  },
]
